import type { DeviceModelOption } from './types';

/**
 * Which colour a device keeps when its model changes: the same one if the new model comes in it
 * too, none otherwise (#186). The backend refuses a device in a colour its model lacks; clearing
 * it here makes the employee choose again instead of meeting that error on save.
 */
export function colorAfterModelChange(
  options: DeviceModelOption[],
  phoneModelId: string,
  colorId: string,
): string {
  const phoneModel = options.find((option) => option.id === phoneModelId);
  return phoneModel?.colors.some((color) => color.id === colorId) ? colorId : '';
}
